import { Component, OnInit, Input, ViewChild, SimpleChange } from '@angular/core';
import { ApexTheme, ChartComponent } from 'ng-apexcharts';
export type ChartOptions = {
  series: any;
  chart: any;
  responsive: any;
  labels: any;
  theme: ApexTheme;
  legend;
};

@Component({
  selector: 'app-vew-donut-chart',
  templateUrl: './vew-donut-chart.component.html',
  styleUrls: ['./vew-donut-chart.component.scss']
})
export class VewDonutChartComponent implements OnInit {
  _objectGraphic:any;
  validator:boolean = false;
  valor: any;

  @ViewChild("chart") chart: ChartComponent;
  public chartOptions: Partial<ChartOptions>;

  @Input() set objectGraphic(value: any) {
    this.validator = this.getValidator(value);
    let argCopy: any=  Object.assign ({}, value);
    this.chartOptions = null;
    this.chartOptions = null;
    this._objectGraphic = argCopy;
    this.chartOptions = argCopy;
    this.chartOptions.legend = Object.assign({}, value.legend);
    console.log("en el view donut", value);
    this.valor = value;
  }

  // Alan: Use input property getter
  get objectGraphic(): any {
    return this._objectGraphic;
  }
  constructor() {
    this.validator = this.getValidator(this.objectGraphic);
    this.chartOptions = this.objectGraphic;
   }


  ngOnInit() {
    this.validator = this.getValidator(this.objectGraphic);
    this.chartOptions = this.objectGraphic;
  }

  getValidator(value){
    if(value === null || value === undefined){
      return false;
    }else{
      return true;
    }
  }

}
